import axios from 'axios';
import { GC_BACKEND } from "shared/util/perfis/exportEnvs";

const TIMEOUT = 120000;

const EXCECAO_DE_TOKEN_INVALIDO = 'io.jsonwebtoken.JwtException';

const onRequestSuccess = (config: any) => {
	const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');

	if (token && token != '' && token != 'null') {
		config.headers.Authorization = `Bearer ${token}`;
	}
	config.timeout = TIMEOUT;
	return config;
};

const onResponseSuccess = (response: any) => {
	if (response.data.token && response.data.token != 'null') {
		localStorage.setItem('jhi-authenticationToken', response.data.token);
	}
	return response;
};

/**
 * Nem toda falha tem resposta: erro de rede, backend fora do ar, requisição cancelada e o
 * timeout de 120s chegam aqui com `response` indefinido, e um 500 pode vir sem corpo.
 * Enquanto os acessos eram diretos, esses casos estouravam um TypeError dentro do próprio
 * interceptor — quem chamou recebia "Cannot destructure property 'status' of undefined" no
 * lugar do erro real, e a causa da falha se perdia.
 */
export const deveEncerrarSessao = (err: any) => {
	const status = err?.response?.status;
	if (status === 401 || status === 504) {
		return true;
	}
	return status === 500 && err?.response?.data?.exception === EXCECAO_DE_TOKEN_INVALIDO;
};

export const onResponseError = (err: any) => {
	if (deveEncerrarSessao(err)) {
		if (localStorage.getItem('jhi-authenticationToken')) {
			localStorage.removeItem('jhi-authenticationToken');
		}
		if (sessionStorage.getItem('jhi-authenticationToken')) {
			sessionStorage.removeItem('jhi-authenticationToken');
		}
		window.location.href = '/';
	}
	return Promise.reject(err);
};
axios.interceptors.request.use(onRequestSuccess);
axios.interceptors.response.use(onResponseSuccess, onResponseError);
axios.defaults.baseURL = GC_BACKEND;
